<template>
  <div class="banner">
    <img alt class="logo" src="../../../../ui/LianPoH5/images/logo.png" />
    <img
      alt
      class="type_logo wechat_logo"
      src="../../../../ui/LianPoH5/images/wechat_logo.png"
      v-if="showWechatLogo"
    />
    <img
      alt
      class="type_logo qq_logo"
      src="../../../../ui/LianPoH5/images/qq_logo.png"
      v-if="showQQLogo"
    />
    <img
      alt
      class="wechat_logo_2"
      src="../../../../ui/LianPoH5/images/wechat_logo_2.png"
      v-if="showWechatLogo"
    />
    <div class="banner_before"></div>
    <div class="banner_after"></div>
    <div class="bg"></div>
    <!-- <div class="title"></div> -->
    <div class="data_content">
      <ActivityCountDown></ActivityCountDown>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ActivityCountDown from "./ActivityCountDown.vue"
import { mapGetters } from "vuex"
export default {
  name: "PageHeader",
  components: {
    ActivityCountDown
  },
  computed: {
    ...mapGetters(["pf"]),
    showQQLogo() {
      return this.pf && this.pf.indexOf("__mds_wzry_tuan_qq") > -1
    },
    showWechatLogo() {
      return this.pf && this.pf.indexOf("__mds_wzry_tuan_wx") > -1
    }
  }
}
</script>

<style scoped>
.banner .bg {
  z-index: 0;
}
.banner_before {
  z-index: 2;
}
.banner_after {
  z-index: 1;
}
</style>
